const Input = ({
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  style = {}
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {label && (
        <label style={{
          fontSize: 11,
          fontWeight: 700,
          color: 'var(--ink-soft)',
          letterSpacing: 0.5,
          textTransform: 'uppercase'
        }}>
          {label}
          {required && <span style={{ color: 'var(--red)', marginLeft: 3 }}>*</span>}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          background: 'var(--white)',
          border: '1.5px solid var(--cream-dark)',
          borderRadius: 12,
          padding: '13px 16px',
          color: 'var(--ink)',
          fontSize: 15,
          transition: 'border-color 0.2s, box-shadow 0.2s',
          ...style
        }}
        onFocus={e => {
          e.target.style.borderColor = 'var(--green)'
          e.target.style.boxShadow = '0 0 0 3px var(--green-pale)'
        }}
        onBlur={e => {
          e.target.style.borderColor = 'var(--cream-dark)'
          e.target.style.boxShadow = 'none'
        }}
      />
    </div>
  )
}

export default Input